module.exports = global["_"] = require("-!/opt/build/repo/node_modules/expose-loader/index.js?lodash!./lodash.js");


//////////////////
// WEBPACK FOOTER
// ./~/lodash/lodash.js-exposed
// module id = 41
// module chunks = 0